// document.addEventListener('DOMContentLoaded', function() {
//   const toggleLinks = document.querySelectorAll('.section-page-header__inner__left__description__toggle-description');

//   toggleLinks.forEach(function(link) {
//     const descriptionContainer = link.closest('.section-page-header__inner__left__description');
//     const shortDescription = descriptionContainer.querySelector('.section-page-header__inner__left__description-short');
//     const fullDescription = descriptionContainer.querySelector('.section-page-header__inner__left__description-full');

//     // Check initial visibility and sync the data-truncated attribute
//     if (shortDescription.classList.contains('lbc-hidden')) {
//       link.setAttribute('data-truncated', 'true');
//     } else {
//       link.setAttribute('data-truncated', 'false');
//     }

//     link.addEventListener('click', function() {
//       const isTruncated = link.getAttribute('data-truncated');
//       const showMoreText = link.getAttribute('data-show-more');
//       const showLessText = link.getAttribute('data-show-less');

//       if (isTruncated === 'true') {
//         // Show short description, hide full description
//         shortDescription.classList.remove('lbc-hidden');
//         fullDescription.classList.add('lbc-hidden');
//         link.textContent = showMoreText;
//         link.setAttribute('data-truncated', 'false');
//       } else {
//         // Hide short description, show full description
//         shortDescription.classList.add('lbc-hidden');
//         fullDescription.classList.remove('lbc-hidden');
//         link.textContent = showLessText;
//         link.setAttribute('data-truncated', 'true');
//       }
//     });
//   });
// });

const leftDescription = document.querySelectorAll('.section-page-header__inner__left__description');

if (leftDescription.length > 0) {
  leftDescription.forEach((description) =>{
    const toggleLink = description.querySelector('.section-page-header__inner__left__description__toggle-description');

    if (toggleLink) {
      if (window.innerWidth > 767) {
        if (description.clientHeight < 92) {
          toggleLink.style.display = 'none';
        }
      } else {
        if (description.clientHeight < 80) {
          toggleLink.style.display = 'none';
        }
      }
    }    

    if (toggleLink) {
      const descriptionText = description.querySelector('.section-page-header__inner__left__description-text');

      toggleLink.addEventListener('click', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        descriptionText.classList.toggle('section-page-header__inner__left__description-text--limited');
        toggleLink.innerHTML = descriptionText.classList.contains('section-page-header__inner__left__description-text--limited') ? toggleLink.getAttribute('data-show-more') : toggleLink.getAttribute('data-show-less');
      });
    }
  });
}